import React, { useEffect, useState } from 'react'
import Sidebar from '../layouts/Sidebar'
import Navbar from '../layouts/Navbar'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Footer from '../layouts/Footer'

const Main = () => {

    const navi =useNavigate()
const [viewData, setViewData] = useState([]);
const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;
  const role =localStorage.getItem("role")
     const getUserDetails = async () => {
    try {
      const response = await axios.get(
        `${api}/Admin/viewemployee`,
        {
          headers: {
            apikey: apikey,
          },
        }
      );
      setViewData(response.data.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);
  return (
    <div>
        <div className="container-scroller">
    
    {/* partial:partials/_navbar.html */}
   <Navbar/>
    {/* partial */}
    <div className="container-fluid page-body-wrapper">
   
      <Sidebar/>
      {/* partial */}
      <div className="main-panel" >
        <div className="content-wrapper">
          <div className="row">
            <div className="col-md-12 grid-margin">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="font-weight-bold mb-0">Dashboard</h4>
                </div>
                <div>
                    {/* <button type="button" className="btn btn-primary btn-icon-text btn-rounded">
                      <i className="ti-clipboard btn-icon-prepend"></i>Report
                    </button> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
           
              {
      role === 'admin' ? <>
       <div className="col-md-3 grid-margin stretch-card">
              <div className="card">
            <Link style={{textDecoration :'none',}} to ='/addemployee'>
                <div className="card-body" >
                  <p className="card-title text-md-center text-xl-left">Employe</p>
                  <div className="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 className="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{viewData.length}</h3>
                    <i className="ti-calendar icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>  
                  <p className="mb-0 mt-2 text-danger">0.12% <span className="text-black ms-1"><small>(30 days)</small></span></p>
                </div>
            </Link>
              </div>
            </div>


            <div className="col-md-3 grid-margin stretch-card">
              <div className="card">
                 <Link style={{textDecoration :'none',}} to ='/salarydetails'>
                <div className="card-body">
                  <p className="card-title text-md-center text-xl-left">Salary</p>
                  <div className="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 className="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">100</h3>
                    <i className="ti-user icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>  
                  <p className="mb-0 mt-2 text-danger">0.47% <span className="text-black ms-1"><small>(30 days)</small></span></p>
                </div>
                </Link>
              </div>
            </div>

                  <div className="col-md-3 grid-margin stretch-card">
              <div className="card">
                 <Link style={{textDecoration :'none',}} to ='/admin/attendance'>
                <div className="card-body">
                  <p className="card-title text-md-center text-xl-left">Attendance</p>
                  <div className="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 className="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">100</h3>
                    <i className="ti-user icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>  
                  <p className="mb-0 mt-2 text-danger">0.47% <span className="text-black ms-1"><small>(30 days)</small></span></p>
                </div>
                </Link>
              </div>
            </div>
             </>
        : <></>
    }






   {(role === 'employee' || role === 'manager') && (
  <>
    <div className="col-md-3 grid-margin stretch-card">
              <div className="card">
                 <Link style={{textDecoration :'none',}} to ='/employ/attendance'>
                <div className="card-body">
                  <p className="card-title text-md-center text-xl-left">My Attendance</p>
                  <div className="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 className="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0"></h3>
                    <i className="ti-user icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>  
                  <p className="mb-0 mt-2 text-danger">0.47% <span className="text-black ms-1"><small>(30 days)</small></span></p>
                </div>
                </Link>
              </div>
            </div>



             <div className="col-md-3 grid-margin stretch-card">
              <div className="card">
                 <Link style={{textDecoration :'none',}} to ='/employ/salary'>
                <div className="card-body">
                  <p className="card-title text-md-center text-xl-left">Salary </p>
                  <div className="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 className="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0"></h3>
                    <i className="ti-user icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>  
                  <p className="mb-0 mt-2 text-danger">0.47% <span className="text-black ms-1"><small>(30 days)</small></span></p>
                </div>
                </Link>
              </div>
            </div>


  </>
)}

{ role === 'manager'&&<>
     <div className="col-md-3 grid-margin stretch-card">
              <div className="card">
                 <Link style={{textDecoration :'none',}} to ='/admin/attendance'>
                <div className="card-body">
                  <p className="card-title text-md-center text-xl-left"> Attendance</p>
                  <div className="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 className="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">100</h3>
                    <i className="ti-user icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>  
                  <p className="mb-0 mt-2 text-danger">0.47% <span className="text-black ms-1"><small>(30 days)</small></span></p>
                </div>
                </Link>
              </div>
            </div>
</>}

           

          </div>
      
        </div>
        <Footer/>
        {/* partial */}
      </div>
      {/* main-panel ends */}
    </div>
    {/* page-body-wrapper ends */}
  </div>
  {/* container-scroller */}
    </div>
  )
}

export default Main
